import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09479631"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "patient-info-header d-flex flex-col mha-font-body-sm" }
const _hoisted_2 = { class: "d-flex flex-row" }
const _hoisted_3 = { class: "patient-name font-style-primary" }
const _hoisted_4 = { class: "d-inline-block" }
const _hoisted_5 = { class: "juno-links d-flex flex-row justify-content-end" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("E")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("B")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("M")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Rx")
const _hoisted_10 = { class: "m-t-32" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mha-font-body-sm font-color-neutral-dark-grey" }, "Patient Status", -1))
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "dependent-warning-bubble" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MicroButton = _resolveComponent("MicroButton")!
  const _component_VerificationStatus = _resolveComponent("VerificationStatus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.patientDisplayName), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_MicroButton, {
          class: "d-inline-block",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openBrowserTab(_ctx.appointment.eChartLink.toString())))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_MicroButton, {
          class: "d-inline-block",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openBrowserTab(_ctx.appointment.billingLink.toString())))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_MicroButton, {
          class: "d-inline-block",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openBrowserTab(_ctx.appointment.masterRecordLink.toString())))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(_component_MicroButton, {
          class: "d-inline-block",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openBrowserTab(_ctx.appointment.rxLink.toString())))
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (!_ctx.isDependent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_VerificationStatus, {
              patient: _ctx.patient,
              "remote-profile-id": _ctx.remoteProfileId
            }, null, 8, ["patient", "remote-profile-id"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, " The patient is a dependent of " + _toDisplayString(_ctx.patient.guardian.first_name) + ", " + _toDisplayString(_ctx.patient.guardian.last_name), 1)
          ]))
    ])
  ]))
}